import React from 'react';

import {
  //AppBar,
  Paper,
  //Tabs,
} from '@mui/material';

//import { EditIcon } from '~/components/icons';
//import { Tooltip } from '~/components/Tooltip';
import { useSidePanel } from '~/contexts/SidePanelContext';
//import { ICreateIssue } from '~/domain/ICreateIssue';
import * as LAYOUT from '~/pages/layout';

//import { CreateIssue } from './CreateIssue';
//import { DisplayIssue } from './DisplayIssue';
//import { IssueList } from './IssueList';
//import { Tab, TabPanel } from './Tab';
import { TabPanel } from './Tab';
import { VehicleConfigurationsContainer } from './VehicleConfigurations';

export const SidePanel = React.memo(function SidePanel() {
  const {
    //issueId,
    tab,
    //view,
    //attachTo: issue,
    //dispatch,
    //modified,
  } = useSidePanel();

  // const handleChange = (
  //   _: React.SyntheticEvent,
  //   tab: 'tab-config' | 'tab-issue'
  // ) => {
  //   dispatch(tab);
  // };

  return (
    <>
      {/* <AppBar
        elevation={0}
        position="static"
        sx={[LAYOUT.HEADER, { background: 'transparent', my: 0 }]}
      > */}
      {/* <Tabs
        value={tab}
        onChange={handleChange}
        textColor="inherit"
        variant="fullWidth"
        sx={{ span: { background: 'transparent' } }}
      > */}
      {/* <Tab label="Configurator" value="tab-config" sx={{ mr: 1.0 }} /> */}
      {/* <Tab
          label="Issues"
          value="tab-issue"
          iconPosition="end"
          sx={{ position: 'relative', ml: 0.5 }}
          icon={
            modified.length > 0 || view === 'create-issue' ? (
              <Tooltip title="Draft">
                <EditIcon
                  sx={({ palette }) => ({
                    position: 'absolute',
                    fontSize: 16,
                    right: '30px',
                    path: { fill: palette.primary.light },
                  })}
                />
              </Tooltip>
            ) : undefined
          }
        /> */}
      {/* </Tabs> */}
      {/* </AppBar> */}
      <Paper
        sx={[
          LAYOUT.CONTAINER,
          {
            borderTopLeftRadius: tab === 'tab-config' ? 0 : 6,
            borderTopRightRadius: tab === 'tab-issue' ? 0 : 6,
            maxHeight: 'calc(100vh - 142px)',
          },
        ]}
      >
        <TabPanel value="tab-config">
          <VehicleConfigurationsContainer />
        </TabPanel>
        {/* <TabPanel value="tab-issue" sx={{ position: 'relative' }}>
          <IssueList hidden={view !== 'list-issues'} />
          {view === 'display-issue' && issueId && (
            <DisplayIssue issueId={issueId} />
          )}
          {view === 'create-issue' && issue && (
            <CreateIssue newIssue={issue as unknown as ICreateIssue} />
          )}
        </TabPanel> */}
      </Paper>
    </>
  );
});
